import React from "react";

const TextBoldNeueIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.75 15.25L6 4.75L9.25 15.25",
  stroke: "currentColor",
  strokeWidth: "1.5",
  vectorEffect: "non-scaling-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4 12.25H8",
  stroke: "currentColor",
  strokeWidth: "1.5",
  vectorEffect: "non-scaling-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.25 12.5C17.25 14.0188 16.0188 15.25 14.5 15.25C12.9812 15.25 11.75 14.0188 11.75 12.5C11.75 10.9812 12.9812 9.75 14.5 9.75C16.0188 9.75 17.25 10.9812 17.25 12.5Z",
  stroke: "currentColor",
  strokeWidth: "1.5",
  vectorEffect: "non-scaling-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.25 9.75V15.25",
  stroke: "currentColor",
  strokeWidth: "1.5",
  vectorEffect: "non-scaling-stroke",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(TextBoldNeueIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;